/* Grill Master theme – white product backgrounds (v1.2.1) */
(() => {
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  /* ---------------- White product backgrounds ----------------
     Product shots with a light-grey studio background get their white point set
     to that grey, so the background turns pure white. Photos without an even,
     neutral border (lifestyle shots) are left untouched. */
  const WHITE_SEL = '.gm-line__img img, .gm-card__media img, .gm-together__img img, .gm-mini img, .gm-gal__item img, .gm-search-thumb img';
  const wpDone = {};
  let wpSvg = null;
  function whitePointFilter(level) {
    const id = `gm-wp-${level}`;
    if (!wpDone[id]) {
      if (!wpSvg) {
        wpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        wpSvg.setAttribute('width', '0'); wpSvg.setAttribute('height', '0');
        wpSvg.setAttribute('aria-hidden', 'true');
        wpSvg.style.position = 'absolute';
        document.body.appendChild(wpSvg);
      }
      const slope = (255 / level).toFixed(4);
      wpSvg.insertAdjacentHTML('beforeend', `<filter id="${id}" color-interpolation-filters="sRGB"><feComponentTransfer><feFuncR type="linear" slope="${slope}"/><feFuncG type="linear" slope="${slope}"/><feFuncB type="linear" slope="${slope}"/></feComponentTransfer></filter>`);
      wpDone[id] = true;
    }
    return id;
  }
  const wpCanvas = document.createElement('canvas');
  wpCanvas.width = 32; wpCanvas.height = 32;
  const wpCtx = wpCanvas.getContext('2d', { willReadFrequently: true });
  function whiten(img) {
    if (img.dataset.gmWp) return;
    if (!img.complete || !img.naturalWidth) { img.addEventListener('load', () => whiten(img), { once: true }); return; }
    img.dataset.gmWp = '1';
    let data;
    try {
      wpCtx.clearRect(0, 0, 32, 32);
      wpCtx.drawImage(img, 0, 0, 32, 32);
      data = wpCtx.getImageData(0, 0, 32, 32).data;
    } catch (err) { return; }
    const lum = [];
    let r = 0, g = 0, b = 0, n = 0, transparent = 0;
    const take = (x, y) => {
      const i = (y * 32 + x) * 4;
      if (data[i + 3] < 250) { transparent++; return; }
      r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
      lum.push((data[i] + data[i + 1] + data[i + 2]) / 3);
    };
    for (let x = 0; x < 32; x++) take(x, 0);
    for (let y = 1; y < 20; y++) { take(0, y); take(31, y); }
    if (transparent > n || n < 20) return;
    r /= n; g /= n; b /= n;
    const mean = (r + g + b) / 3;
    const chroma = Math.max(r, g, b) - Math.min(r, g, b);
    const sd = Math.sqrt(lum.reduce((a, v) => a + (v - mean) * (v - mean), 0) / n);
    if (mean >= 251 || mean < 185 || chroma > 14 || sd > 7) return;
    const level = Math.max(185, Math.round(mean - 2));
    img.style.filter = `url(#${whitePointFilter(level)})`;
  }
  function initWhite(root = document) { $$(WHITE_SEL, root).forEach(whiten); }
  initWhite();
  if ('MutationObserver' in window) {
    new MutationObserver((list) => {
      list.forEach((m) => m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(WHITE_SEL)) whiten(node);
        else initWhite(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
